export default __webpack_public_path__ + "static/media/vocal_line_icon.26b88dcd.png";